import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  deletedAlertContact: null,
  allCustomers: [],
  allCustomersReadAll: [],
  archivedCustomers: [],
  currentCustomer: {}, // customer selected in dropdown/from customer table
  currentCustomerOnboardingData: {},
  customer: {}, // the logged-in user's customer/company
  customerName: null,
  newCustomer: {},
  updatedCustomer: {},
  deletedCustomer: {},
  ssoConfigSettings: {}, // SSO Configuration Settings for current customer
  toggleModal: false,
  toggleSAMLSettingsModal: false,
  customerEmailRecipients: [],
  toggleEmailRecipientsModal: false,
  customerEmailRecipientsbyType: [],
  stnActiveEngineerUsers: [],
  createEmailRecipient: {},
  vmQuota: null,
  updateVmQuota: {},
  addVmQuota: {},
  remainingQuota: {},
  cmdbServices: {},
  alerts: {},
  updateCmdbServices: {},
  updateAlertServices: {},
  addCmdbServices: {},
  customerEmailRecipientsSIEMAlerts: {},
  isLoading: false,
  stnEngineer: [],
  error: [],
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    start: (state, action) => {
      state.isLoading = true;
      state.error = [];
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setCustomerName: (state, action) => {
      state.customerName = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setVmQuota: (state, action) => {
      state.vmQuota = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUpdateVmQuota: (state, action) => {
      state.updateVmQuota = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAddVmQuota: (state, action) => {
      state.addVmQuota = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setRemainingQuota: (state, action) => {
      state.remainingQuota = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCmdbServices: (state, action) => {
      state.cmdbServices = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAlertService: (state, action) => {
      state.alerts = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUpdateCmdbServices: (state, action) => {
      state.updateCmdbServices = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUpdateAlertServices: (state, action) => {
      state.updateAlertServices = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAddCmdbServices: (state, action) => {
      state.addCmdbServices = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAllCustomers: (state, action) => {
      state.allCustomers = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAllCustomersReadAll: (state, action) => {
      state.allCustomersReadAll = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setArchivedCustomers: (state, action) => {
      state.archivedCustomers = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomerEmailRecipientsSIEMAlerts: (state, action) => {
      state.customerEmailRecipientsSIEMAlerts = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomerEmailRecipients: (state, action) => {
      state.customerEmailRecipients = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomerEmailRecipientsbyType: (state, action) => {
      state.customerEmailRecipientsbyType = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCurrentCustomer: (state, action) => {
      state.currentCustomer = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCurrentCustomerOnboardingData: (state, action) => {
      state.currentCustomerOnboardingData = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    getStnEngineerUsers: (state, action) => {
      state.stnEngineer = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    getStnActiveEngineerUsers: (state, action) => {
      state.stnActiveEngineerUsers = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomer: (state, action) => {
      state.customer = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setNewCustomer: (state, action) => {
      state.newCustomer = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDeletedCustomer: (state, action) => {
      state.deletedCustomer = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDeletedAlertContact: (state, action) => {
      state.deletedAlertContact = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setSsoConfigSettings: (state, action) => {
      state.ssoConfigSettings = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setToggleModal: (state, action) => {
      state.toggleModal = !state.toggleModal;
    },
    setToggleSAMLSettingsModal: (state, action) => {
      state.toggleSAMLSettingsModal = !state.toggleSAMLSettingsModal;
    },
    setToggleEmailRecipientsModal: (state, action) => {
      state.toggleEmailRecipientsModal = !state.toggleEmailRecipientsModal;
    },
    setSsoConfigSettingsError: (state, action) => {
      state.ssoConfigSettings = {};
      state.error = action.payload;
    },
    setResetCustomer: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setCustomerName,
  setVmQuota,
  setUpdateVmQuota,
  setAddVmQuota,
  setRemainingQuota,
  setCmdbServices,
  setUpdateCmdbServices,
  setAddCmdbServices,
  setAllCustomers,
  setAllCustomersReadAll,
  setArchivedCustomers,
  setCustomerEmailRecipientsSIEMAlerts,
  setCustomerEmailRecipients,
  setCustomerEmailRecipientsbyType,
  setCurrentCustomer,
  setCustomer,
  setNewCustomer,
  setDeletedCustomer,
  setDeletedAlertContact,
  setSsoConfigSettings,
  setToggleModal,
  setToggleSAMLSettingsModal,
  setToggleEmailRecipientsModal,
  setSsoConfigSettingsError,
  setAlertService,
  setUpdateAlertServices,
  getStnEngineerUsers,
  setResetCustomer,
  getStnActiveEngineerUsers,
  setCurrentCustomerOnboardingData,
} = customerSlice.actions;

export default customerSlice.reducer;
